import React, { useEffect, useState } from "react";
import styles from "./PropertyInformation.module.css";
import Header from "../../Header/Header";
// import ProgressBar from "./ProgressBar";
import { useNavigate } from "react-router-dom";
import config from "../../../config";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import GeoSearch from "../../../components/PropertyComponent/GeoSearch";
import { AiOutlineSearch } from "react-icons/ai";
import { getAddressComponent } from "../../../helpers/Helper";
import { showErrorToast } from "../../utils";
import ProgressBar from "../../../components/ProgressBar";
const InspectionPropertyInfo = () => {
    const navigate = useNavigate();

    // State variables to capture form input
    const [address, setAddress] = useState("");
    const [city, setCity] = useState("");
    const [state, setState] = useState("");
    const [zipCode, setZipCode] = useState("");
    const [unitNumber, setUnitNumber] = useState("");
    const storageInfo = JSON.parse(sessionStorage.getItem("insuranceInfo"));
    useEffect(() => {
        if (storageInfo?.propertyInfo) {
            const propertyInfo = storageInfo.propertyInfo;
            setAddress(propertyInfo.address);
            setState(propertyInfo.state);
            setCity(propertyInfo.city);
            setZipCode(propertyInfo.zipCode);
        }
    }, []);
    const handleSubmit = async (e) => {
        e.preventDefault(); // Prevent the default form submission behavior

        // Validate form inputs
        if (!validateForm()) return;

        const authUserToken = localStorage.getItem("authUser");
        const authUser = authUserToken ? authUserToken.replace(/^"|"$/g, "") : "";

        try {
            // sessionStorage.setItem("insuranceInfo", JSON.stringify({ ...storageInfo, propertyInfo: { address, state, city, zipCode } }));

            navigate("/services/home-inspection-Schedule", {
                state: { propertyInfo: { address, state, city, zipCode } },
            });
            // const response = await fetch(`${config.get("API_URL")}/personal_info`, {
            //     method: "POST",
            //     headers: {
            //         "Content-Type": "application/json",
            //         Authorization: `Bearer ${authUser}`,
            //     },
            //     body: JSON.stringify({
            //         first_name: firstName,
            //         last_name: lastName,
            //         email: email,
            //         phone_number: phoneNumber,
            //         address: address,
            //         unit_number: unitNumber,
            //     }),
            // });
            // const responseData = await response.json(); // Parse the response body
            // if (response.ok) {
            //     console.log("Response:", responseData); // Log the response
            //     showSuccessToast("Form submitted successfully!");
            //     navigate("/services/insurance-quote/step-2");
            // } else {
            //     console.log("Error Response:", responseData); // Log the error response
            //     showErrorToast(`Failed to submit: ${responseData.message || "Please try again."}`);
            // }
        } catch (error) {
            console.error("Error submitting the form:", error);
            showErrorToast("An error occurred. Please try again.");
        }
    };

    useEffect(() => {
        document.title = `Insurance | ${config.get("COMPANY_NAME")}`;
    }, []);

    const validateForm = () => {
        if (!address || !city || !state || !zipCode) {
            showErrorToast("Please fill in all fields.");
            return false;
        }
        // // Email validation
        // const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        // if (!emailRegex.test(email)) {
        //     showErrorToast("Please enter a valid email address.");
        //     return false;
        // }

        return true; // If everything is valid
    };

    return (
        <div className={`${styles.container} tw-h-screen  tw-bg-background_color`}>
            <main className={`${styles.mainContent} tw-h-full`}>
                <Header title="Home Inspection" />
                <section className={`${styles.formSection}  tw-h-full tw-mt-[30px] tw-overflow-auto tw-flex tw-flex-col `}>
                    <ProgressBar currentStep={2} totalSteps={3} />
                    {/* <div></div> */}
                    <div className={`${styles.formContainer}  tw-mt-10`}>
                        <h1 className={styles.formTitle}>Property Details</h1>

                        <form className={styles.generalForm} onSubmit={handleSubmit}>
                            <div className={styles.formRow}>
                                <div className={styles.fieldContainer}>
                                    <label className={styles.fieldLabel}>Property Address</label>
                                    <div className="tw-filter-search-wrapper tw-mt-2 tw-w-full tw-select-filter   tw-bg-[#101010]  tw-rounded-lg tw-text-sm tw-text-gray-700 tw-flex-grow">
                                        <GeoSearch
                                            onBoundingBoxUpdate={(boundingBox, place) => {
                                                setAddress(place.formatted_address);
                                                setCity(getAddressComponent(place.address_components, "locality"));
                                                setState(getAddressComponent(place.address_components, "administrative_area_level_1"));
                                                setZipCode(getAddressComponent(place.address_components, "postal_code"));
                                            }}
                                            deleteSearchLocation={() => {}}
                                            isSimple={true}
                                            address={address}
                                            // className="search-box-filter"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className={styles.formRow}>
                                <div className={styles.fieldContainer}>
                                    <label className={styles.fieldLabel}>City</label>
                                    <input
                                        type="text"
                                        className={`${styles.fieldInput} tw-mt-2`}
                                        placeholder="Enter your City"
                                        required={true}
                                        value={city}
                                        maxLength={50} // Max length for city
                                        onChange={(e) => {
                                            const value = e.target.value.replace(/[^a-zA-Z\s]/g, ""); // only letters & spaces
                                            setCity(value);
                                        }}
                                    />
                                </div>

                                <div className={styles.fieldContainer}>
                                    <label className={styles.fieldLabel}>State</label>
                                    <input
                                        type="text"
                                        className={`${styles.fieldInput} tw-mt-2`}
                                        placeholder="Select State"
                                        value={state}
                                        maxLength={30} // Max length for state
                                        onChange={(e) => {
                                            const value = e.target.value.replace(/[^a-zA-Z\s]/g, ""); // only letters & spaces
                                            setState(value);
                                        }}
                                    />
                                </div>

                                <div className={styles.fieldContainer}>
                                    <label className={styles.fieldLabel}>Zip Code</label>
                                    <input
                                        type="number"
                                        maxLength={5}
                                        className={`${styles.fieldInput} tw-mt-2`}
                                        placeholder="Enter your Zip Code"
                                        required={true}
                                        value={zipCode}
                                        onChange={(e) => {
                                            if (e.target.value.length <= 5) {
                                                setZipCode(e.target.value);
                                            }
                                        }}
                                    />
                                </div>
                            </div>
                            <p className="tw-text-secondary tw-italic">Using the address autocomplete feature can save time and ensure accuracy.</p>
                            <div className="tw-flex tw-justify-center tw-w-full">
                                <button type="submit" className={`${styles.submitButton} tw-bg-primary hover:tw-bg-primary_hover tw-w-fit`}>
                                    Next: Coverage Preferences{" "}
                                </button>
                            </div>
                        </form>
                    </div>
                    <div></div>
                </section>
            </main>
        </div>
    );
};

export default InspectionPropertyInfo;
